angular.module('satv.mediastats.app', [
    'satv.mediastats',
    'ui.router'
], ['$interpolateProvider', function($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
}])

.config(['$stateProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider', 'config', function($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, config) {

    //template helper
    function tpl(t) {
        return config.templateRoot + '/' + t + '?version=' + config.app_release_id;
    }

    var fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 1);

    $urlRouterProvider.otherwise('/search?type=audition&sortBy=mre.createdDate&sortOrder=DESC&includeTotal=true');

    $urlMatcherFactoryProvider.type('context', {
        name : 'context',
        decode: function(val)  {
            return typeof(val) ==="string" ? JSON.parse(val) : val;
        },
        encode: function(val)  {
            return JSON.stringify(val);
        },
        equals: function(a, b) {
            return this.is(a) && this.is(b) && a.name === b.name && a.data == b.data
        },
        is: function(val)      {
            return angular.isObject(val) && "name" in val && "data" in val
        }
    });

    $stateProvider
        .state('statSearch', {
            url: "/search?textQuery&{sortBy:string}&{sortOrder:string}&{type:string}&{fromDate:date}&{toDate:date}&{groupBy:string}&{includeTotal:bool}&{context:context}",
            controller: 'MediaStatsSearchCtrl',
            templateUrl: tpl('media/stats/templates/search')
        })
    ;
}])

;


// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/app.js